import { useMemo } from "react";
import { Rise } from "../components/Reveal";
import { LeadForm, FormIntro } from "../components/LeadForm";
import { Anteprima } from "../components/Anteprima";
import { useTexts } from "../lib/settings";
import { COPY } from "../content/copy";
import { FormFirstLayout } from "../components/FormFirstLayout";
import { readRecord } from "../lib/consent/storage";

// variante advertorial del pitch: ?v=A|B|C, altrimenti a caso una volta e ricordata
const pickVariant = (variants) => {
    const ids = variants.map((v) => v.id);
    if (!readRecord()?.categories.analytics) return ids[0];
    try {
        const q = (new URLSearchParams(window.location.search).get("v") || "").toUpperCase();
        if (ids.includes(q)) localStorage.setItem("apf-variant", q);
        const saved = localStorage.getItem("apf-variant");
        if (ids.includes(saved)) return saved;
        const pick = ids[Math.floor(Math.random() * ids.length)];
        localStorage.setItem("apf-variant", pick);
        return pick;
    } catch {
        return ids[0];
    }
};

export default function ComeSiComincia() {
    const f = COPY.form;
    const variant = useMemo(() => f.variants.find((v) => v.id === pickVariant(f.variants)), [f.variants]);

    return (
        <section id="cominciare" className="section cominciare" data-testid="cominciare-block" data-variant={variant.id}>
            <FormFirstLayout testId="home-analysis-layout"
                intro={<FormIntro caption={f.caption} titleA={f.titleA} titleB={f.titleB} sub={f.sub} mobileSub={f.mobileSub} />}
                form={<LeadForm position="middle" extra variant={variant.id} />}
                proof={<>
                    <Rise delay={0.15}>
                        <p className="body pitch-text" data-testid="form-pitch">{variant.pitch}</p>
                    </Rise>
                    <Rise delay={0.2}>
                        <div className="deliver" data-testid="form-deliver">
                            <p className="caption">{f.deliverTitle}</p>
                            <ol className="deliver-list">
                                {variant.bullets.map((b, i) => (
                                    <li key={b}><span className="deliver-num">{String(i + 1).padStart(2, "0")}</span><span>{b}</span></li>
                                ))}
                            </ol>
                        </div>
                    </Rise>
                    <Anteprima id="anteprima-home" />
                </>}
            />
        </section>
    );
}

export function Chiusura() {
    const t = useTexts();
    const c = { title: t.chiusura_title, sub: t.chiusura_sub, closing: t.chiusura_closing };
    return (
        <section className="section chiusura" data-testid="chiusura-block">
            <div className="container lead-grid">
                <div className="lead-pitch">
                    <FormIntro titleA={c.title} sub={c.sub} testId="closing-form" />
                    <Rise delay={0.15}><p className="caption closing-line">{c.closing}</p></Rise>
                </div>
                <div className="lead-side">
                    <LeadForm position="bottom" closing={c.closing} />
                </div>
            </div>
        </section>
    );
}
